// TranslatorNavigationTag component
import React from "react";
import { useSelector } from "react-redux";

const TranslatorNavigationTag = ({ children }) => {
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  if (!translations) {
    return children;
  }
  const findTranslation = (category, key) => {
    let translationCategory;
    if (translations) {
      translationCategory = translations?.translations?.find(
        (item) => item.category === category
      );
    }
    if (!translationCategory) return key;

    const translationItem = translationCategory?.languageWord?.find(
      (item) => item.variable === key
    );
    return translationItem ? translationItem?.translate : key;
  };

  const translatedText = findTranslation("navigation", children);

  return <>{translatedText}</>;
};

// TranslatorDashboardTag component
const TranslatorDashboardTag = ({ children }) => {
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  if (!translations) {
    return children;
  }

  const findTranslation = (category, key) => {
    const translationCategory = translations?.translations?.find(
      (item) => item.category === category
    );
    if (!translationCategory) return key;

    const translationItem = translationCategory?.languageWord?.find(
      (item) => item.variable === key
    );
    return translationItem ? translationItem?.translate : key;
  };

  const translatedText = findTranslation("dashboard", children);

  return <>{translatedText}</>;
};

// TranslatorTimesheetag component
const TranslatorTimesheetTag = ({ children }) => {
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  if (!translations) {
    return children;
  }

  const findTranslation = (category, key) => {
    const translationCategory = translations?.translations?.find(
      (item) => item.category === category
    );
    if (!translationCategory) return key;

    const translationItem = translationCategory.languageWord?.find(
      (item) => item.variable === key
    );
    return translationItem ? translationItem.translate : key;
  };

  const translatedText = findTranslation("timesheet", children);

  return <>{translatedText}</>;
};

// TranslatorPayrollTag component
const TranslatorPayrollTag = ({ children }) => {
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  if (!translations) {
    return children;
  }

  const findTranslation = (category, key) => {
    const translationCategory = translations?.translations?.find(
      (item) => item.category === category
    );
    if (!translationCategory) return key;

    const translationItem = translationCategory.languageWord?.find(
      (item) => item.variable === key
    );
    return translationItem ? translationItem.translate : key;
  };

  const translatedText = findTranslation("payroll", children);

  return <>{translatedText}</>;
};

// TranslatorRecruitTag component
const TranslatorRecruitTag = ({ children }) => {
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  if (!translations) {
    return children;
  }

  const findTranslation = (category, key) => {
    const translationCategory = translations?.translations?.find(
      (item) => item.category === category
    );
    if (!translationCategory) return key;

    const translationItem = translationCategory.languageWord?.find(
      (item) => item.variable === key
    );
    return translationItem ? translationItem.translate : key;
  };

  const translatedText = findTranslation("recruit", children);

  return <>{translatedText}</>;
};

// TranslatorReportTag component
const TranslatorReportTag = ({ children }) => {
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  if (!translations) {
    return children;
  }

  const findTranslation = (category, key) => {
    const translationCategory = translations?.translations?.find(
      (item) => item.category === category
    );
    if (!translationCategory) return key;

    const translationItem = translationCategory.languageWord?.find(
      (item) => item.variable === key
    );
    return translationItem ? translationItem.translate : key;
  };

  const translatedText = findTranslation("report", children);

  return <>{translatedText}</>;
};

// TranslatorCompanyTag component
const TranslatorCompanyTag = ({ children }) => {
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  if (!translations) {
    return children;
  }

  const findTranslation = (category, key) => {
    const translationCategory = translations?.translations?.find(
      (item) => item.category === category
    );
    if (!translationCategory) return key;

    const translationItem = translationCategory.languageWord?.find(
      (item) => item.variable === key
    );
    return translationItem ? translationItem.translate : key;
  };

  const translatedText = findTranslation("company", children);

  return <>{translatedText}</>;
};

// TranslatorSupportTag component
const TranslatorSupportTag = ({ children }) => {
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  if (!translations) {
    return children;
  }

  const findTranslation = (category, key) => {
    const translationCategory = translations?.translations?.find(
      (item) => item.category === category
    );
    if (!translationCategory) return key;

    const translationItem = translationCategory.languageWord?.find(
      (item) => item.variable === key
    );
    return translationItem ? translationItem.translate : key;
  };

  const translatedText = findTranslation("support", children);

  return <>{translatedText}</>;
};

export {
  TranslatorNavigationTag,
  TranslatorDashboardTag,
  TranslatorTimesheetTag,
  TranslatorPayrollTag,
  TranslatorRecruitTag,
  TranslatorReportTag,
  TranslatorCompanyTag,
  TranslatorSupportTag,
};
